<app-rfi-answer-completeness [completeness]="completeness()" />
<app-rfi-metric-grid [cards]="cards()" />
<div class="flex flex-col gap-2">
  <h4 class="font-semibold">
    {{ 'project.steps.providerResults.individual.hrCloudBreakdown' | transloco }}
  </h4>
  @for (part of employeeBreakdown(); track part.labelKey) {
    <div class="grid grid-cols-[12rem_1fr_5rem] items-center gap-3 text-sm">
      <span>{{ part.labelKey | transloco }}</span>
      <app-score-bar [percentage]="part.share" color="var(--p-primary-color)" />
      <span class="text-right">
        @if (part.value === null) {
          {{ 'project.steps.providerResults.individual.notSpecified' | transloco }}
        } @else {
          {{ part.value | appNumber: '1.0-0' }}
        }
      </span>
    </div>
  }
</div>
